/**
 * Layout de impressão como TEXTO de largura fixa (as mesmas colunas da bobina): base da
 * visualização na tela e do documento compartilhado como texto (WhatsApp, e-mail...). Puro:
 * serve à API, ao ERP Web e ao CaféGestor Vendedor.
 */
import type { PrintLayout } from "./fiscal";

/** Uma linha do layout como ela sai na bobina (texto já alinhado e se é negrito). */
export type LayoutRow = { text: string; bold: boolean };

/**
 * O layout como texto de largura fixa (as mesmas colunas da bobina): base da visualização na
 * tela e do Pedido de Venda compartilhado como texto (WhatsApp, e-mail...).
 */
export function layoutRows(layout: PrintLayout): LayoutRow[] {
  const w = layout.widthChars;
  const rows: LayoutRow[] = [];
  for (const l of layout.lines) {
    if (l.t === "rule") rows.push({ text: "-".repeat(w), bold: false });
    else if (l.t === "feed") for (let i = 0; i < l.lines; i++) rows.push({ text: "", bold: false });
    else if (l.t === "qr") rows.push({ text: "[QR Code]".padStart((w + 9) / 2), bold: false });
    else if (l.t === "pair") {
      const gap = Math.max(1, w - l.left.length - l.right.length);
      rows.push({ text: `${l.left}${" ".repeat(gap)}${l.right}`, bold: Boolean(l.bold) });
    } else {
      const pad =
        l.align === "center"
          ? Math.max(0, Math.floor((w - l.text.length) / 2))
          : l.align === "right"
            ? Math.max(0, w - l.text.length)
            : 0;
      rows.push({ text: `${" ".repeat(pad)}${l.text}`, bold: Boolean(l.bold) });
    }
  }
  return rows;
}

/** O layout inteiro como texto simples (sem espaços sobrando no fim das linhas). */
export function layoutText(layout: PrintLayout): string {
  return layoutRows(layout)
    .map((r) => r.text.replace(/\s+$/, ""))
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/^\n+/, "")
    .trimEnd();
}
